<template>
    <div>
        <h5>Permission Lists</h5>
        <permission-list-table></permission-list-table>
    </div>
</template>

<script>
import PermissionListTable from './PermissionListTable.vue';

export default {
    name: 'Permission',
    components: { PermissionListTable },
};
</script>
